// reducer.js
import { TALENT_SUBMISSION_REQUEST, TALENT_SUBMISSION_SUCCESS, TALENT_SUBMISSION_FAILURE, TALENT_SEARCH_REQUESTS_FETCH, TALENT_SEARCH_REQUESTS_FETCH_SUCCESS, TALENT_SEARCH_REQUESTS_FETCH_FAILURE, TALENT_SEARCH_REQUEST_UPDATE, TALENT_SEARCH_REQUEST_UPDATE_SUCCESS, TALENT_SEARCH_REQUEST_UPDATE_FAILURE } from '../actions/Types';

// Initial state
const initialState = {
    submitting: false,
    success: false,
    error: null,
    submissionData: null,

    requests: [],
    loading: false,
};

const TalentSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case TALENT_SUBMISSION_REQUEST:
            return {
                ...state,
                submitting: true,
                success: false,
                error: null,
            };

        case TALENT_SUBMISSION_SUCCESS:
            return {
                ...state,
                submitting: false,
                success: true,
                submissionData: action.payload,
            };

        case TALENT_SUBMISSION_FAILURE:
            return {
                ...state,
                submitting: false,
                success: false,
                error: action.payload,
            };


        case TALENT_SEARCH_REQUESTS_FETCH:
            return { ...state, loading: true, error: null };
        case TALENT_SEARCH_REQUESTS_FETCH_SUCCESS:
            return { ...state, loading: false, requests: action.payload };
        case TALENT_SEARCH_REQUESTS_FETCH_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case TALENT_SEARCH_REQUEST_UPDATE:
            return { ...state };
        case TALENT_SEARCH_REQUEST_UPDATE_SUCCESS:
            const updatedRequests = state.requests.map(request =>
                request.id === action.payload.id
                    ? { ...request, status: action.payload.status }
                    : request
            );
            return { ...state, requests: updatedRequests };
        case TALENT_SEARCH_REQUEST_UPDATE_FAILURE:
            return { ...state, error: action.payload };

        default:
            return state;
    }
};

export default TalentSearchReducer;
